import type { AxiosResponse } from 'axios'
import ResponseError from './ResponseError'
export default class ResponseError500 extends ResponseError {
  declare response: AxiosResponse

  constructor(message: string, cause: Error, response: AxiosResponse) {
    super(message, cause, response)

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    // @ts-ignore
    if (Error.captureStackTrace) {
      // @ts-ignore
      Error.captureStackTrace(this, ResponseError500)
    }

    this.name = 'ResponseError500'

    // CustomData
    this.response = response
  }
}
